import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { filterLiteCrmContactColumns } from '../helpers';
import SaleRow from 'components/comps/table/sale_row';
import { toggleSelectSale } from '../store/actions/select_list';

export const SaleRowContainer = ({ currentColumns, edgeCrm, ...props }) => {
  const columns = edgeCrm
    ? filterLiteCrmContactColumns(currentColumns)
    : currentColumns;

  return (
    <SaleRow
      {...props}
      currentColumns={columns}
      edgeCrm={edgeCrm}
    />
  );
};

SaleRowContainer.propTypes = {
  currentColumns: PropTypes.array.isRequired,
  currentUser: PropTypes.object.isRequired,
  edgeCrm: PropTypes.bool,
  sale: PropTypes.object.isRequired,
  selected: PropTypes.bool,
  onSelect: PropTypes.func
};

const mapStateToProps = state => ({
  currentColumns: state.session.currentSaleColumns,
  currentUser: state.scope.currentUser,
  customFieldSchemas: state.customFieldSchemas,
  edgeCrm: state.features.edgeCrm,
});

const mapDispatchToProps = {
  onSelect: toggleSelectSale
};

export default connect(mapStateToProps, mapDispatchToProps)(SaleRowContainer);
